module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_sapporo-2b4819d23362a40491173aa251335533.jpg";